import React, { useEffect, useState } from "react";
import "./login.css";
import login_img from "../../../assets/image/login-img.png";
import { useNavigate } from "react-router-dom";
import { AdminLogin } from "../../../axios";
import logo from "../../../assets/image/instabloodLogo.svg";
import { useAuthStore } from "../../../store/auth";
import { Alert, Button, CircularProgress } from "@mui/material";
import { FormPassword, FormTextInput } from "../../components/form-components";
import { useForm } from "react-hook-form";
import { useToast } from "use-toast-mui";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { emailMessage, requiredMessage, stringMessage } from "../../../config";

/* ================= Validation ================= */

const schema = yup.object({
  email: yup
    .string(stringMessage)
    .email(emailMessage)
    .required(requiredMessage),
  password: yup.string(stringMessage).required(requiredMessage),
});

function Login() {
  const navigate = useNavigate();
  const toast = useToast();

  const [errMessage, setErrMessage] = useState("");
  const [formLoading, setFormLoading] = useState(false);

  const setAuthenticated = useAuthStore(
    (state) => state.setAuthenticated
  );

  const { handleSubmit, control } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
    resolver: yupResolver(schema),
  });

  /* ================= Already Logged In ================= */
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      navigate("/panel/dashboard", { replace: true });
    }
  }, [navigate]);

  /* ================= Submit ================= */
  const onSubmit = (newData) => {
    setFormLoading(true);
    setErrMessage("");

    const formData = {
      user: {
        email: newData.email,
        password: newData.password,
      },
    };

    AdminLogin(formData)
      .then((res) => {
        const token = res.data.token.access_token;

        toast.success("Successfully logged in!");
        setAuthenticated(token);
        localStorage.setItem("access_token", token);

        navigate("/panel/dashboard", { replace: true });
      })
      .catch((e) => {
        setErrMessage(
          e?.response?.data?.message || "Invalid email or password"
        );
      })
      .finally(() => {
        setFormLoading(false);
      });
  };

  return (
    <div className="login-bg">
      <div className="container">
        <div className="row align-items-center min-vh-100">
          <div className="col-md-7 d-none d-md-block">
            <img
              src={login_img}
              alt="login"
              className="img-fluid"
            />
          </div>

          <div className="col-md-4">
            <div className="card-login">
              <div className="instaBlood_logo">
                <img src={logo} alt="Instablood Logo" />
              </div>

              <h3>Sign In</h3>

              {errMessage && (
                <Alert className="mb-2" severity="error">
                  {errMessage}
                </Alert>
              )}

              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-2">
                  <FormTextInput
                    name="email"
                    control={control}
                    label="Email"
                  />
                </div>

                <div className="mb-4">
                  <FormPassword
                    name="password"
                    control={control}
                    label="Password"
                  />
                </div>

                <Button
                  fullWidth
                  type="submit"
                  size="large"
                  disabled={formLoading}
                  startIcon={
                    formLoading ? (
                      <CircularProgress size={20} />
                    ) : null
                  }
                  variant="contained"
                >
                  LOGIN
                </Button>
                <br/>
                <div
  style={{
    marginTop: "14px",
    textAlign: "center",
    fontSize: "12px",
    color: "#777",
    lineHeight: "1.5",
  }}
>
  © {new Date().getFullYear()}{" "}
  <strong>INVINCIX Solutions Pvt. Ltd.</strong>
  <br />
  Instablood Admin · v
  {process.env.REACT_APP_VERSION || "1.0.0"}
</div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
